application.register("comp_cards_stack", class extends Stimulus.Controller {
    async connect() {
        const self = this;

        this._cards = self.targets.findAll('card')
        this._gsapTweens = [];
        await importScript([cdnjs.gsap, cdnjs.gsapScrollTrigger]);
        gsap.registerPlugin(ScrollTrigger);

        ScrollTrigger.matchMedia({
            '(min-width: 60em)': () => {
                const timeline = gsap.timeline({
                    scrollTrigger: {
                        trigger: self.targets.find('scene'),
                        start: 'top top',
                        end: `+${99 * self._cards.length}%`,
                        scrub: true,
                        pin: true
                    }
                })

                this._gsapTweens.push(timeline)

                self._cards.forEach((card, index) => {
                    ScrollTrigger.saveStyles(card)
                    let start = '90vh'

                    if(index === 0) {
                        start = '-50%'
                    }

                    timeline.fromTo(card, {
                        translateY: start
                    }, {
                        translateY: `${-50 - ((self._cards.length - index - 1) * 5)}%`,
                    }, '>-175%')

                    timeline.to(card, {
                        scale: 1 - ((self._cards.length - index - 1) * 0.05)
                    }, '<+=20%')

                    if(index !== self._cards.length - 1) {
                        timeline.to(card, {
                            opacity: 0.5
                        }, '>+50%')
                    }
                })
            }
        })
    }

    disconnect() {
        if (!this._gsapTweens) {
            return
        }

        this._gsapTweens.forEach((tween) => {
            if (tween.scrollTrigger) {
                tween.scrollTrigger.kill()
            }

            tween.kill()
        })

        this._gsapTweens = []
    }
})
